import { Employer } from '../app/models/employer';
import { EmployerInterface } from '../app/interface/employer';
import { AdditionalIncome } from '../app/models/additionalincome';
import { IncomeInfo } from '../app/models/incomeinfo';
import { IncomeInfoInterface } from '../app/interface/incomeinfo';

import { ApplicationDataService } from './application.service'

import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class EmployerDataService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private applicationService: ApplicationDataService) { }

    getEmploymentInformation(RentalApplicationKey: string, RentalApplicantKey: string, AddAdditionalApplicantKey: string, yardiKey: string) {
        return this.http.get<IncomeInfoInterface>(EmployerDataService._API_ENDPOINT + 'Application/GetApplicantEmploymentInfo?RentalApplicantKey='
            + RentalApplicantKey + '&AddAdditionalApplicantKey=' + AddAdditionalApplicantKey + '&yardiKey=' + yardiKey, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <IncomeInfoInterface>(response))
            );
    }

    updateEmploymentInformation(RentalApplicantKey: number, RentalApplicationKey: number, CompletedByOther: boolean, Employers: Employer[], additionalIncome: AdditionalIncome) {
        let income: IncomeInfo = new IncomeInfo();
        income.additionalIncome = additionalIncome || new AdditionalIncome();
        income.employments = Employers;
        return this.http.post<EmployerInterface[]>(EmployerDataService._API_ENDPOINT + 'Application/UpdateEmploymentInfo?RentalApplicantKey=' +
            RentalApplicantKey + '&RentalApplicationKey=' + RentalApplicationKey + '&CompletedByOther=' + CompletedByOther, income, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <EmployerInterface[]>(response))
            );
    }

    getRentalPetTypes(RentalApplicantKey: number) {
        return this.http.get<EmployerInterface[]>(EmployerDataService._API_ENDPOINT + 'Application/GetEmploymentInfo?RentalApplicantKey=' +
            RentalApplicantKey, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <EmployerInterface[]>(response))
            );
    }

}
